module.exports = __webpack_public_path__ + "img/hakuna_bg2.898972f7.jpg";